// Generated file : do not modify
export enum ContratArticleTypes
{
  NONE = 0,
  EMPLOYEUR,
  SALARIE,
  ARTICLE
};

import Contrat from '@/extend/classes/Contrat';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Articles de contrat
export default class ContratArticle  {
  // Identifiant unique
  public id: number;
  // Titre
  public titre: string;
  // Type d'article
  public type: ContratArticleTypes;
  // Numéro d'article
  public numero: number;
  // Conventions applicables (vide = toutes)
  public conventionIds: number[];
  // Métiers applicables (vide = tous)
  public metierIds: number[];
  // Contrat en cours d'édition'
  public contratId: number;
  // Template associé
  public templateId: number;
  // position dans le template'
  public ordre: number;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.titre = '';
    this.type = ContratArticleTypes.NONE;
    this.numero = 0;
    this.conventionIds = [];
    this.metierIds = [];
    this.contratId = 0;
    this.templateId = 0;
    this.ordre = 0;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: ContratArticle): ContratArticle {
    const newContratArticle: ContratArticle = new ContratArticle();
    newContratArticle.id = obj.id;
    newContratArticle.titre = obj.titre;
    newContratArticle.type = obj.type;
    newContratArticle.numero = obj.numero;
    newContratArticle.conventionIds = JSON.parse(JSON.stringify(obj.conventionIds));
    newContratArticle.metierIds = JSON.parse(JSON.stringify(obj.metierIds));
    newContratArticle.contratId = obj.contratId;
    newContratArticle.templateId = obj.templateId;
    newContratArticle.ordre = obj.ordre;
    newContratArticle.canUpdate = obj.canUpdate;
    newContratArticle.canDelete = obj.canDelete;
    newContratArticle.display = obj.display;
    newContratArticle.clientId = obj.clientId;
    newContratArticle.notifDefType = obj.notifDefType;
    return newContratArticle;
  }

  public toJsonContratArticle (): string {
    const json = {
      titre: this.titre,
      type: this.type,
      numero: this.numero,
      conventionIds: this.conventionIds,
      metierIds: this.metierIds,
      contratId: this.contratId,
      templateId: this.templateId,
      ordre: this.ordre,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromContratArticle (obj: ContratArticle): void {
    this.id = obj.id;
    this.titre = obj.titre;
    this.type = obj.type;
    this.numero = obj.numero;
    this.conventionIds = obj.conventionIds;
    this.metierIds = obj.metierIds;
    this.contratId = obj.contratId;
    this.templateId = obj.templateId;
    this.ordre = obj.ordre;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareContratArticle (value: ContratArticle): boolean {
    return (this.toJsonContratArticle() == value.toJsonContratArticle());
  }

  public cloneContratArticle (): ContratArticle {
    return ContratArticle.fromJson(this);
  }

  public static canEdit (contrat: Contrat): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contratarticles/canEdit', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(contratArticles: ContratArticle[]) {
  }
}
